<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Uitgaven voor tijdelijk verblijf thuis van een gehandicapte
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Verzorgde je in het weekend of tijdens de vakantie een gehandicapte van 21 jaar of ouder die meestal in
                een instelling (bijvoorbeeld een Wlz-instelling) verbleef? En heeft de gehandicapte daarvoor recht op
                Wlz-zorg? En maakte je extra kosten voor de verzorging thuis of op een vakantieadres? Dan mag je onder
                voorwaarden de uitgaven voor het halen en brengen van de gehandicapte én de verzorging thuis of op een
                vakantieadres aftrekken.
                <div class="space10"></div>

                Je krijgt de aftrek voor de verzorging van:
                <li class="list">je gehandicapte kinderen</li>
                <li class="list">je gehandicapte broers of zussen</li>
                <div class="space10"></div>

                Heeft de kantonrechter je benoemd tot mentor van een gehandicapte? Of ben je een curator voor een
                gehandicapte? Dan geldt de voorwaarde dat je de persoonlijke belangen van een gehandicapte behartigt. Je
                kunt daarbij bijvoorbeeld denken aan de belangen omtrent de verzorging, verpleging, behandeling of
                begeleiding van de gehandicapte.
                <div class="space10"></div>

                Let op!
                Kosten die je mag aftrekken als 'Uitgaven voor tijdelijk verblijf thuis van gehandicapten van 21 jaar of
                ouder' mag je niet (nogmaals) aftrekken als zorgkosten.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Welke uitgaven voor tijdelijk verblijf thuis gehandicapten zijn aftrekbaar
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je mag de volgende kosten aftrekken:<br/>
                <li class="list">extra kosten door het verblijf van de gehandicapte<br/>
                    Hiervoor geldt een vaste aftrek per dag. De dagen waarop
                    de gehandicapte wordt gehaald of gebracht tellen ook mee. Vul het totaal aantal dagen in {{ this.year}} in.</li>
                <li class="list">uitgaven voor het halen en brengen met de auto<br/>
                    Hiervoor geldt een aftrek van vaste bedrag per kilometer. Je neemt
                    altijd de afstand van huis naar de verzorgingsinstelling en terug, ook al reis je bijvoorbeeld in
                    vakanties over een andere afstand. Vul het aantal gereisde dagen en het km's van een enkele reis in {{ this.year}} in.</li>
                Een eventuele ontvangen vergoeding vermindert de uitgaven voor tijdelijk verblijf thuis gehandicapten.
            </div>
        </div>
    </div>
</div>



